import { useMutation } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';

export interface ResetPasswordParams {
  email: string;
  locationId: string;
  password: string;
}

export const resetPassword = async (params: ResetPasswordParams) => {
  const response = await baseAPI.post<unknown>('/auth/reset-password', params);

  return response.data;
};

export const useResetPasswordMutation = () => {
  return useMutation({
    mutationFn: resetPassword,
  });
};
